import React from "react";
import "../assets/Css/vision.css";
import "../index.css"
export default function Vision() {
  return (
    <>
      <section className="vision-contain page-width">
        <div className="vision-wrapper">
          <div className="vision-caption">
            <p>Our vision</p>
          </div>
          <div className="vision-title">
            <h1>
            We're more than a branding agency <br /> – we simplify, elevate, <br /> and transform daily 
            </h1>
          </div>
          <div className="vision-content-wrapper">
            <div className="vision-cont">
            <div className="cont1">
              <p>
              A thirty-person digital dream team, ready to support you throughout the creation and development of your identity, branding, and product, is the beating heart of our Parisian design hub. We are a group of disruptors, explorers, and image architects that combine technical and creative skills for the success of your business. We range from tech maestros to creative geniuses, project orchestrators to online pioneers. Our goal? will assist you in establishing the ideal balance between UI and UX design, finding the delicate equilibrium between innovation and user conformance. We harmonize the beautiful and the utilitarian in our design sanctuary to make sure they coexist harmoniously.
              </p>
              </div>
            </div>
            <div className="vision-cont">
              <div className="cont2">
                <p>
                We support creativity as a transdisciplinary energy that permeates the arts. Every partnership is more than just a project; it's a chance to explore previously unexplored creative spaces, with your satisfaction serving as the only limit. We offer our experience, steadfast dedication, and limitless enthusiasm to support your project—whether we're launching a new brand or rebranding an existing one. Anticipate a noticeable and quantifiable effect on specific areas of your company, such as your total turnover and conversion and bounce rates. Our skillful and committed work is the canvas that we paint with your success....
                </p>
              </div>

              <div className="cont2">
                <h2>Our culture</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
